export function HxEmpty({ icon, children, ...rest }) {
  return (
    <div className="hx-empty" {...rest}>
      <div className="hx-empty__icon">{icon}</div>
      {children}
      <img src="/brand/hbf-logo-3d-wm.png" alt="" aria-hidden="true" className="hx-empty__brand" draggable={false} />
    </div>
  );
}
